import Api from '../api';

export type CompanyFieldOrigin = 'cadastro' | 'salvo' | 'vazio';

export interface CompanyRepresentante {
  nome: string | null;
  cpf: string | null;
  rg: string | null;
  cargo: string | null;
}

export interface CompanyBanco {
  banco: string | null;
  agencia: string | null;
  conta: string | null;
}

export interface CompanyCustomField {
  id: string;
  nome: string;
  valor: string;
  ordem?: number;
}

export interface ProposalCompanyData {
  [campo: string]: unknown;
  representante_legal?: CompanyRepresentante;
  dados_bancarios?: CompanyBanco;
}

export interface ProposalCompanyResponse {
  dados: ProposalCompanyData;
  origem: Record<string, CompanyFieldOrigin>;
  rotulos: Record<string, string>;
  excluidos: string[];
  campos_personalizados: CompanyCustomField[];
  dados_bancarios_exigidos: boolean;
  confirmada: boolean;
  confirmada_em: string | null;
  confirmada_por: { id: number; nome: string | null } | null;
}

export interface ProposalCompanyPayload {
  cnpj: string;
  dados: ProposalCompanyData;
  rotulos?: Record<string, string>;
  excluidos?: string[];
  campos_personalizados?: CompanyCustomField[];
  salvar_no_perfil?: boolean;
}

export interface MonitoredCompany {
  cnpj: string;
  nome: string | null;
}

const basePath = (biddingId: number) => `/gestao_ia/licitacoes/${biddingId}/proposta`;

export const getProposalCompany = (biddingId: number, cnpj: string) =>
  Api.get<ProposalCompanyResponse>(`${basePath(biddingId)}/empresa`, { params: { cnpj } });

export const updateProposalCompany = (biddingId: number, payload: ProposalCompanyPayload) =>
  Api.put<ProposalCompanyResponse>(`${basePath(biddingId)}/empresa`, payload);

export const confirmProposalCompany = (biddingId: number, cnpj: string, confirmada: boolean) =>
  Api.patch<ProposalCompanyResponse>(`${basePath(biddingId)}/empresa/confirmacao`, {
    cnpj,
    confirmada,
  });

export const listMonitoredCompanies = () =>
  Api.get<{
    empresas: Array<{ monitored_company?: string; cnpj?: string; company_name?: string }>;
  }>('/documentos/empresas_monitoradas');
